import { Link, RouteWrapper, Subtitle } from '@/views/CrehanaLegal/components';

const RefundPolicy = () => (
  <RouteWrapper>
    <section>
      <p>
        Consideraciones generales <strong>aplicables a reembolsos</strong> que{' '}
        <strong>todo usuario</strong> debe tener en cuenta:
      </p>
      <ul>
        <li>
          <strong>
            No se realizan reembolsos por pagos efectuados con Pago Efectivo,
            Oxxo Pay, SPEI, RapiPago, Efecty, PSE y Rappi (aplica para cursos
            individuales/sueltos, packs y membresías).
          </strong>
        </li>
        <li>
          <strong>
            Al tratarse de una devolución, es probable que el valor reintegrado
            a la tarjeta de cada usuario cubra los costos adicionales generados
            como intereses y recargos. Esto ocurre por los trámites que debe
            ejecutar la entidad bancaria con la pasarela de pagos
            correspondiente.
          </strong>
        </li>
        <li>
          <strong>
            Para todos los casos, se debe haber hecho el pago con tarjeta de
            crédito, tarjeta de débito o Paypal.
          </strong>
        </li>
      </ul>
    </section>
    <section>
      <Subtitle>1. Cursos, packs: políticas de reembolso</Subtitle>
      <p>
        Recuerda que tienes la opción de solicitar el cambio de cursos o recibir
        créditos equivalentes a tu compra, siempre y cuando estén dentro de los
        14 primeros días después de realizada la compra.
      </p>
      <ul>
        <li>
          No se realizan reembolsos por pagos efectuados con Pago Efectivo, Oxxo
          Pay, SPEI, RapiPago, Efecty, Ebanx y PSE.
        </li>
        <li>
          No podrás solicitar un reembolso si ya obtuviste un certificado del
          curso.
        </li>
        <li>
          No podrás solicitar un reembolso si el curso tiene más del 30% de
          progreso.
        </li>
        <li>
          En caso de emitir el reembolso total o parcial, el estudiante pierde
          el acceso al curso y/o pack de cursos.
        </li>
      </ul>
      <p>
        En caso el curso no cumpla con tus expectativas, y deseas solicitar un
        reembolso, tenemos las siguientes opciones para ti:
      </p>
      <p>
        Para todos los casos, debes haber hecho el pago con tarjeta de
        crédito/débito o Paypal. En caso el curso no cumpla con tus
        expectativas, y deseas solicitar un reembolso, tenemos las siguientes
        opciones para ti:
      </p>
      <Subtitle>Cursos individuales:</Subtitle>
      <ul>
        <li>
          La devolución será al 100% siempre y cuando hayas realizado la compra
          en un lapso no mayor a 14 días calendario anteriores a tu solicitud de
          devolución y el progreso de las clases sea mayor al 5% y menor al 15%.
        </li>
        <li>
          La devolución será al 70% si tu compra fue en un lapso menor o igual a
          14 días y tu progreso de las clases no supera el 30%.
        </li>
        <li>
          En caso de superar el 30% de progreso de tu curso, podemos ayudarte
          con un cambio** (solo se puede hacer el cambio por única vez) o añadir
          créditos a tu cuenta de Crehana para tu próxima compra.
        </li>
      </ul>
      <Subtitle>Packs:</Subtitle>
      <ul>
        <li>
          La devolución será al 100% siempre y cuando hayas realizado la compra
          en un lapso de tiempo no mayor a 14 días calendario anteriores a tu
          solicitud de devolución y el progreso de cada curso sea mayor al 5% y
          menor al 15%.
        </li>
        <li>
          La devolución será al 70% si tu compra fue en un lapso menor o igual a
          14 días y el progreso de cada curso no supera el 30%.
        </li>
        <li>
          En el caso de que alguno de los cursos supere el 30% de progreso, el
          reembolso no será efectuado.
        </li>
        <li>
          Si alguno de los cursos no cumplió tus expectativas o lo elegiste por
          error, podemos ayudarte con el cambio (solo se puede hacer el cambio
          por única vez) o añadir créditos a tu cuenta de Crehana para tu
          próxima compra.
        </li>
        <li>
          Si no se cumple con alguno de los puntos antes mencionados, no hay
          lugar a cambio y/o reembolso.
        </li>
        <li>
          En caso solicites una devolución luego de los 14 días de compra, el
          reembolso no procederá.
        </li>
        <li>
          Es importante resaltar que al comprar un pack de cursos estás
          adquiriendo cursos con descuento y a promoción única, por lo que no
          realizamos reembolsos por uno o dos de los cursos del pack.
        </li>
      </ul>
      <p>
        Es importante resaltar que al comprar un pack de cursos estás
        adquiriendo cursos con descuento y promoción única, por lo que no
        realizamos reembolsos por uno o dos de los cursos del pack.
      </p>
      <p>
        <strong>
          (**) Puedes leer condiciones aquí 👉{' '}
          <Link
            href="https://ayuda.crehana.com/s/article/Solicitud-de-cambio-de-cursos"
            label="Condiciones de la solicitud del cambio de cursos."
          />
        </strong>
      </p>
      <p>
        <strong>
          Ten en cuenta generar la solicitud de reembolso con los datos
          correctos (requisitos, nombre del producto a reembolsar), pues de lo
          contrario no se aplicará tu solicitud.
        </strong>
      </p>
      <p>
        Esperamos que no llegues a tener ningún inconveniente, pero si es así,
        solo envíanos un email a <Link href="hola@crehana.com" /> con los
        siguientes detalles:
      </p>
      <ul>
        <li>Reembolso como asunto del email.</li>
        <li>Correo de registro y/o compra.</li>
        <li>Nombre del producto.</li>
        <li>Motivo de la solicitud.</li>
        <li>
          Si optas por un cambio, envíanos el link del curso nuevo (solo se
          puede hacer el cambio por única vez).
        </li>
      </ul>
    </section>
    <section>
      <Subtitle>2. Membresías: políticas de reembolso</Subtitle>
      <p>
        Recuerda que al adquirir una membresía (Estudiantil, Individual, Dúo o
        Familiar), estás aceptando la compra de un plan anual (pago único y por
        adelantado), por lo que antes de la compra te brindamos toda la
        información detallada de los beneficios con los que contarás:
      </p>
      <ul>
        <li>
          No se realizan reembolsos por pagos efectuados con Pago Efectivo, Oxxo
          Pay, SPEI, RapiPago, Efecty, PSE y Rappi.
        </li>
        <li>
          Para solicitar el reembolso del 100% debes estar dentro de los
          primeros 14 días de compra y no tener un progreso mayor al 15% en
          alguno de los cursos**.
        </li>
        <li>
          En caso de emitir el reembolso parcial o total, el estudiante pierde
          el acceso a la membresía y los cursos inscritos.
        </li>
      </ul>
      <p>
        En caso de emitir el reembolso parcial o total, el estudiante pierde el
        acceso a la membresía.
      </p>
      <ul>
        <li>
          La devolución será al 100% si la solicitud se realiza antes de los 14
          días y se tiene un progreso igual o menor al 15% en cualquiera de los
          cursos inscritos.
        </li>
        <li>
          Si el progreso de los cursos es mayor al 15%, se tomará en cuenta el
          precio actual del curso o cursos para ser descontado de la membresía y
          recibirás una devolución de lo restante. Siempre cuando hayas
          realizado la compra en un plazo no mayor a 14 días calendario
          anteriores a tu solicitud de devolución**.
        </li>
        <li>
          En caso solicites una devolución luego de los 14 días de compra, el
          reembolso no procederá**.
        </li>
        <li>
          Si no se cumple con alguno de los puntos antes mencionados, no hay
          lugar a reembolso.
        </li>
        <li>
          Si tu membresía se autorenovó y no cancelaste tu suscripción,{' '}
          <strong>no es posible obtener una devolución de dinero.</strong>{' '}
          Tampoco se podrán obtener créditos por los periodos de membresía
          utilizados parcialmente o por el contenido de Crehana no usado durante
          la suscripción anual. Toda la información es comunicada previamente en
          los términos y condiciones aceptados al momento de la compra inicial y
          en el mail de bienvenida premium.
        </li>
      </ul>
      <p>
        <strong>Recuerda que nuestras membresías son autorenovables,</strong>{' '}
        Una vez finalizado el período de un año (12 meses), la suscripción se
        autorenueva por el precio inicial de la compra y el monto es debitado de
        la última tarjeta vinculada a la plataforma.
      </p>
      <p>
        En caso desees cancelar tu suscripción y evitar la renovación antes de
        la fecha de vencimiento, puedes hacerlo desde tu panel de configuración:{' '}
        <Link href="https://www.crehana.com/configuracion/#/suscripcion">
          https://www.crehana.com/configuracion/#/suscripcion.
        </Link>
      </p>
      <p>
        <strong>
          Ten en cuenta generar la solicitud de reembolso con los datos
          correctos (requisitos, nombre del producto a reembolsar), pues de lo
          contrario no se aplicará tu solicitud.
        </strong>
      </p>
      <p>
        <strong>
          (**) Estas condiciones de reembolso no son aplicables para
          renovaciones automáticas de membresía.
        </strong>
      </p>
      <p>
        Esperamos que no llegues a tener ningún inconveniente, pero si es así,
        solo envíanos un email a <Link href="premium@crehana.com" /> con los
        siguientes detalles:
      </p>
      <ul>
        <li>“Reembolso membresía” como asunto del email</li>
        <li>Correo de registro y/o compra</li>
        <li>Motivo de la solicitud</li>
        <li>
          Imagen del comprobante de pago y/o 4 últimos dígitos de la tarjeta
          desde la cual se hizo la compra.
        </li>
      </ul>
      <p>
        <strong>
          Preguntas frecuentes sobre reembolsos de cursos, packs y membresías
        </strong>
      </p>
      <p>
        <strong>“¿Puedo solicitar un reembolso si pagué con Apple?”</strong>
      </p>
      <p>
        En el caso de pagos realizados desde la aplicación para iOS, la
        solicitud de reembolso debe gestionarse directamente con el área de
        soporte de Apple. Puedes ver más información aquí:
        <Link href="https://support.apple.com/es-es/HT204084" />
      </p>
      <p>
        <strong>“¿En cuánto tiempo veré el reembolso en mi cuenta?”</strong>
      </p>
      <p>
        Si tu solicitud de reembolso cumple con todos los requisitos,
        realizaremos el proceso de inmediato; sin embargo, esto puede tomar un
        tiempo extra para reflejarse en tu cuenta:
      </p>
      <ul>
        <li>
          Tarjeta de crédito/débito: de 10 a 15 días hábiles, dependiendo de tu
          banco.
        </li>
        <li>Paypal: 30 días hábiles, dependiendo de tu banco.</li>
        <li>
          Los reembolsos se realizan en la misma moneda en la que se realizó el
          cobro inicial en nuestro sistema.
        </li>
      </ul>
    </section>
    <section>
      <Subtitle>3. Microdegree: políticas de reembolso</Subtitle>
      <p>
        En caso tu experiencia en el <strong>MicroDegree</strong> no cumpla con
        tus expectativas y deseas solicitar un reembolso, debes tener en
        consideración lo siguiente:
      </p>
      <ul>
        <li>
          La devolución será al <strong>100%</strong> siempre y cuando el
          progreso de tu primer curso sea <strong>menor al 30%.</strong>
        </li>
        <li>
          La devolución será al <strong>100%</strong> siempre y cuando se
          solicite dentro de los primeros <strong>7 días calendario</strong> de
          empezado el primer mes de clase.
        </li>
        <li>
          Si no cumples con <strong>ambos</strong> requisitos (1 y 2), tu
          solicitud no procederá.
        </li>
      </ul>
      <p>“¿En cuánto tiempo veré el reembolso en mi cuenta?”</p>
      <p>
        Si tu solicitud de reembolso cumple con todos los requisitos,
        realizaremos el proceso de inmediato; sin embargo, esto puede tomar un
        tiempo extra para reflejarse en tu cuenta:
      </p>
      <ul>
        <li>
          <strong>Tarjeta de crédito/débito:</strong> de 10 a 15 días hábiles,
          dependiendo de tu banco.
        </li>
        <li>
          <strong>Paypal:</strong> 30 días hábiles, dependiendo de tu banco.
        </li>
      </ul>
      <p>
        <strong>
          *Los reembolsos se realizan en la misma moneda en la que se realizó el
          cobro inicialmente.
        </strong>
      </p>
      <p>“¿Y si compré con un método de pago en efectivo?”</p>
      <p>
        Si realizaste la compra con Conekta/Oxxo (México), Efecty o PSE
        (Colombia), Pago Efectivo (Perú) o{' '}
        <strong>RapiPago / PagoFácil (Argentina)</strong>, la devolución será a
        través de una transferencia bancaria y debes seguir los siguientes
        pasos:
      </p>
      <ul>
        <li>
          Envíanos un mensaje a <Link href="md@crehana.com" /> con el asunto
          “Reembolso MicroDegree”.
        </li>
        <li>
          Datos completos: nombres y apellidos, documento de identidad, número
          de cuenta bancaria e interbancaria, banco, país.
        </li>
        <li>
          La transferencia se realizará dentro de 15 días hábiles luego de
          confirmada la solicitud.
        </li>
      </ul>
      <Subtitle>
        *Los reembolsos se realizan en la misma moneda en la que se realizó el
        cobro inicialmente.
      </Subtitle>
      <p>
        “¿Y si no puedo llevar el MicroDegree y ya pasaron los días permitidos
        de devolución?”
      </p>
      <p>
        En caso no puedas empezar el programa en la fecha de inicio indicada en
        tu inscripción, tu caso pasará a evaluación por parte del equipo de
        Crehana. Se dará la opción de trasladar el inicio de tu programa a la
        siguiente fecha de inicio siempre y cuando se solicite dentro de los
        primeros 14 días calendario de empezado el primer mes del MicroDegree y
        si cumples con alguna de estas condiciones:
      </p>
      <ul>
        <li>
          Temas de salud (física o mental): envíanos tu certificado o constancia
          médica. <br /> ⚠️Si durante el desarrollo del programa te ves afectado
          por COVID, envíanos todos los documentos correspondientes para que tu
          caso sea evaluado por el equipo encargado.
        </li>
      </ul>
      <p>
        Para que tu caso se evalúe envía un correo a{' '}
        <Link href="md@crehana.com" /> con el asunto: “Cambio de inicio
        Microdegree”. El plazo de respuesta a estas solicitudes se realizará en
        los 2 días laborables posteriores al envío. El cambio se tendrá en
        cuenta únicamente para efectos académicos. Aún cuando se aducen razones
        de salud, no modificará el monto de los pagos a los que el alumno se ha
        comprometido, y el inicio será en la fecha solicitada, previa
        evaluación. Ten presente que si anteriormente accediste a una solicitud
        de cambio no podrás aplicar en una nueva oportunidad. Asimismo, queda
        fuera la posibilidad de solicitar el reembolso por el valor de tu
        programa.
      </p>
      <p>
        En caso no cumplas con la condición estipulada para solicitar un cambio
        de fecha de inicio, ten en cuenta que evaluaremos tu caso y podría estar
        sujeta al pago de una nueva inscripción al programa.
      </p>
      <Subtitle>
        * No aplica si el alumno ya solicitó el cambio una vez.
      </Subtitle>
      <p>“¿Puedo llevar más de un Microdegree a la vez?”</p>
      <p>
        De momento, no es posible, nuestros MicroDegrees están diseñados para
        que aprendas de manera ágil y efectiva siguiendo una ruta de aprendizaje
        personalizada.
      </p>
      <p>¿Qué sucede si me inscribí a más de un microdegree por error?</p>
      <p>
        Deberás contactar a un asesor educativo enviando un correo a
        <Link href="md@crehana.com" />, con el{' '}
        <strong>asunto: Doble Microdegree</strong>, para analizar tu caso y
        buscar una solución.
      </p>
      <p>
        Estamos aquí para brindarte el mejor servicio, darte una solución lo más
        pronto posible y comunicar nuevas mejoras partiendo de tus experiencias.
      </p>
    </section>
    <section>
      <Subtitle>4. Bootcamp: políticas de reembolso</Subtitle>
      <p>
        Podrás acceder al reembolso de tu dinero al 100%; siempre y cuando, se
        haya solicitado hasta un día antes de la fecha de inicio del Bootcamp.
      </p>
      <p>
        De igual forma, si durante el desarrollo del programa deseas acceder al
        reembolso de tu dinero, te invitamos a escribirnos a hola@crehana.com
        con el asunto &quot;Reembolso - Bootcamp&quot; para evaluar tu
        solicitud. Ten en cuenta que si este fuera tu caso, tienes opción a
        solicitarlo como máximo dentro de los primeros 7 días calendario de
        empezado la primera semana de clase. El equipo encargado evaluará tu
        caso para determinar cuál es el monto a devolver.
      </p>
      <p>
        Es importante que tengas presente que el plazo de devolución dependerá
        de tu entidad bancaria y podría tomar hasta 15 días hábiles. Asimismo,
        al solicitar el reembolso no tendrás posibilidad de recibir algún
        diploma y/o constancia.
      </p>
      <p>
        No aplica si el alumno ya solicitó el cambio de fecha de inicio una vez.
      </p>
      <p>
        <strong>Preguntas frecuentes sobre reembolsos de Bootcamp:</strong>
      </p>
      <p>
        <strong>“¿En cuánto tiempo veré el reembolso en mi cuenta?”</strong>
      </p>
      <p>
        Si tu solicitud de reembolso cumple con todos los requisitos,
        realizaremos el proceso de inmediato; sin embargo, esto puede tomar un
        tiempo extra para reflejarse en tu cuenta:
      </p>
      <ul>
        <li>
          <strong>Tarjeta de crédito/débito</strong>: de 10 a 15 días hábiles,
          dependiendo de tu banco.
        </li>
        <li>
          <strong>Paypal</strong>: 30 días hábiles, dependiendo de tu banco.
        </li>
      </ul>
      <p>
        <strong>“¿Y si compré con un método de pago en efectivo?”</strong>
      </p>
      <p>
        Si realizaste la compra con Conekta/Oxxo (México), Efecty o PSE
        (Colombia), Pago Efectivo (Perú), Rappi o RapiPago / PagoFácil
        (Argentina), la devolución será a través de una transferencia bancaria y
        debes seguir los siguientes pasos:
      </p>
      <ul>
        <li>
          Envíanos un mensaje a <Link href="hola@crehana.com" /> con el asunto
          “Reembolso - Bootcamp”.
        </li>
        <li>
          Datos completos: nombres y apellidos, documento de identidad, número
          de cuenta bancaria e interbancaria, banco, país.
        </li>
        <li>
          La transferencia se realizará dentro de 15 días hábiles luego de
          confirmada la solicitud.
        </li>
      </ul>
      <p>
        <strong>
          “¿Y si no puedo llevar el Bootcamp y ya pasaron los días permitidos de
          devolución?”
        </strong>
      </p>
      <p>
        Si durante el desarrollo del Programa te ves afectado por algún problema
        de salud (física o mental) envíanos tu certificado o constancia médica a
        {` `}
        <Link href="hola@crehana.com" /> con el asunto &quot;Cambio de Inicio -
        Bootcamp&quot; para que tu caso sea evaluado por el equipo encargado.
      </p>
      <p>
        Ten presente que si anteriormente accediste a una solicitud de cambio no
        podrás aplicar en una nueva oportunidad. Asimismo, queda fuera la
        posibilidad de solicitar el reembolso por el valor total o parcial de tu
        Programa.
      </p>
      <p>
        En caso no cumplas con la condición estipulada para solicitar un cambio
        de fecha de inicio, ten en cuenta que evaluaremos tu caso y podría estar
        sujeto al pago de una nueva inscripción.
      </p>
      <p>
        El cambio se tendrá en cuenta únicamente para efectos académicos. Aún
        cuando se aducen razones de salud, no modificará el monto del pago a los
        que el alumno se ha comprometido, y el inicio estará sujeto al
        cronograma de apertura de nuestros Bootcamps.
      </p>
    </section>
  </RouteWrapper>
);

export default RefundPolicy;
